<div class="w-full flex pt-6 pb-6 px-12 items-center justify-center gap-2">

  <div class="flex gap-2 flex-3 flex-row items-center justify-start">

    @if (_config.menu) {
      <button (click)="toggleMenu()" class="btn btn-neutral-outline rounded-icon">
        <img alt="Sidebar" class="w-8" src="/assets/icons/feather/sidebar.svg">
      </button>
    }

    @if (_config.company && !authState.isAdmin()) {
      <button (click)="handleCompanyClick()"
              [class.company-logo-btn]="hasCompanyLogo()"
              [class.opacity-60]="!canSelectCompany()"
              [disabled]="!canSelectCompany()"
              class="!hidden xl:!flex btn btn-neutral-outline rounded-icon {{hasCompanyLogo() ? '' : '!p-3'}}">
        @if (hasCompanyLogo()) {
          <img (error)="handleLogoError()"
               [src]="getCompanyLogoUrl(getCompanyId())"
               alt="Company"
               class="company-logo-img">
        } @else {
          <img alt="Company" class="w-full object-contain opacity-10" src="/assets/icons/feather/image.svg">
        }
      </button>
    }

    @if (_config.view) {
      <button class="!hidden xl:!flex btn btn-neutral-outline rounded-icon">
        <img alt="View" class="w-8" src="/assets/icons/feather/eye.svg">
      </button>
    }

  </div>

  @if (_config.search) {
    <div class="search hidden xl:flex flex-2 mx-auto flex-col items-center justify-center">
      <input autocomplete="off" name="search-text" placeholder="Por ejemplo:  Planes y tareas" type="text">
    </div>
  }

  <div class="flex gap-2 flex-3 flex-row items-center justify-end">

    @if (_config.settings) {
      <button class="!hidden lg:!flex btn btn-neutral-outline rounded-icon">
        <img alt="Sidebar" class="w-8" src="/assets/icons/feather/settings.svg">
      </button>
    }

    @if (_config.notifications) {
      <div class="relative">
        <button (click)="toggleNotifications()" class="!hidden lg:!flex btn btn-neutral-outline rounded-icon relative">
          <img alt="Notification" class="w-8" src="/assets/icons/feather/bell.svg">
          @if (unreadCount > 0) {
            <span class="notification-badge">{{ unreadCount > 9 ? '9+' : unreadCount }}</span>
          }
        </button>

        @if (showNotifications) {
          <div class="notifications-panel shadow-e1">
            <div class="flex items-center gap-2">
              <h6 class="font-semibold">Notificaciones</h6>
              <button (click)="toggleNotifications()" class="btn ml-auto !p-1">
                <img alt="Close" class="h-4" src="/assets/icons/feather/x.svg">
              </button>
            </div>

            @if (notificationsLoading) {
              <div class="flex items-center gap-2 text-neutral-500 italic">
                <img alt="Loading" class="h-4 loader-icon" src="/assets/icons/feather/loader.svg">
                <span>Cargando notificaciones...</span>
              </div>
            } @else if (notificationsError) {
              <p class="text-neutral-500 italic">{{ notificationsError }}</p>
            } @else if (!notifications.length) {
              <p class="text-neutral-500 italic">No hay notificaciones.</p>
            } @else {
              <core-notification-tray
                (action)="executeNotificationAction($event)"
                [items]="previewNotifications"
                [loadingIds]="readingNotificationIds"
                [showClose]="false"
                class="max-h-[24rem] w-full compact"/>
              <button (click)="goToNotifications()" class="btn btn-link self-start !px-0" type="button">
                <span class="cd-text-b3 font-medium">Ver más</span>
              </button>
            }
          </div>
        }
      </div>
    }

    @if (_config.user) {
      <div class="flex gap-2 flex-row items-center">

        <button class="btn btn-neutral-outline avatar"></button>

      <div class="flex flex-col">
          @if (getCompanyName()) {
            <span class="cd-text-md text-neutral-600 truncate">{{ getCompanyName() }}</span>
          }
          <span
            class="cd-text-lg text-neutral-800 truncate">{{ authState.user()?.firstName }} {{ authState.user()?.lastName }}</span>
          @if (_config.role) {
            <span class="cd-text-md text-neutral-600">{{ companyState.membership()?.role?.name }}</span>
          }
      </div>
      </div>
    }

  </div>

</div>

@if (_config.subHeader) {
  <div class="!hidden xl:!flex w-full pt-2 px-12 pb-8 items-center justify-center">

    <div class="flex flex-col justify-start">
      <h3 class="cd-text-mono" style="font-style: italic">
        Bienvenido, {{ authState.user()?.firstName }} 👋
      </h3>
      <h4 class="text-neutral-500" style="font-weight: 500">Aquí tienes tu resumen</h4>
    </div>

    @if (_config.calendar) {
      <div class="flex ml-auto gap-2 flex-row items-center justify-start gap-8">

        <div class="flex flex-row gap-3 items-center">

          <button class="btn btn-neutral-outline rounded-icon" style="width: 5rem;height: 5rem">
            <b class="text-[2.375rem]" style="">{{ currentDate.dayNumber }}</b>
          </button>

          <span class="text-lg text-neutral-700 w-[8rem]" style="font-weight: 400">
        {{ currentDate.dayName }} {{ currentDate.dayNumber }} <br/> de {{ currentDate.monthName }}
      </span>

        </div>

        <hr class="h-[3.125rem] bg-neutral-300" style="width: 1px;"/>

        <button (click)="goToMyPlan()" class="btn btn-primary flex flex-row gap-4 items-center" style="border-radius: 2rem">
          <span class="cd-text-n truncate">Ir a mi plan</span>
          <img alt="Chevron-right" class="filter-neutral-100 h-4" src="/assets/icons/feather/chevron-right.svg">
        </button>

        <button class="!hidden xl:!flex btn btn-neutral-outline rounded-icon"
                style="width: 2.5rem;height: 2.5rem; padding: 0">
          <img alt="Calendar" class="w-5 filter-neutral-500" src="/assets/icons/feather/calendar.svg">
        </button>

      </div>
    }

  </div>
}
